<h1 mat-dialog-title>Add Crack Records</h1>
<div mat-dialog-content>
 
 
    <mat-form-field class="example-full-width">
      <input type="text" matInput placeholder="CrackName" 
      [(ngModel)]="CrackName"
      >
    </mat-form-field>
  
    <mat-form-field class="example-full-width">
      <input type="text" matInput placeholder="Comment" 
      [(ngModel)]="Comment"
      
      >
    </mat-form-field>
    <mat-form-field class="example-full-width">
      <input type="text" matInput placeholder="Crack Length" 
      [(ngModel)]="CrackLength"
      
      >
    </mat-form-field>

    <!-- <upload-component-crack-photo (onPhotoUpload)="uploadComponentCrackPhotos($event)" [uploadEndPoint]="1"
    [relatedId]="wsreId" [WSREMeasurementPointID]="MeasurementPointID"></upload-component-crack-photo> -->
 
</div>
<div mat-dialog-actions class="dialogControllBtn">
  <button mat-raised-button (click)="onNoClick()">Cancel</button>
  <button mat-raised-button (click)="onSubmitClick()" cdkFocusInitial>Submit</button>
</div>